import Debug from 'debug';

const debug = Debug('whiteboard:analytics');

export default function trackEvent(
  reference: string,
  eventName: string,
  data = {}
) {
  const tracker = window.AhaAnalytics;
  debug(`Tracking event: ${reference} ${eventName}, ${JSON.stringify(data)}`);

  if (!tracker) {
    return;
  }

  tracker.track(reference, eventName, data);
}
